'use strict';

var Carousel = require('./lib/carousel');

module.exports = Carousel;
